export const MAX_RECONNECTION_COUNT = 10;
export const RECONNECTION_DELAY_MS = 2000;
